import { render, staticRenderFns } from "./CharColor.vue?vue&type=template&id=7fb2b415&scoped=true&"
import script from "./CharColor.vue?vue&type=script&lang=js&"
export * from "./CharColor.vue?vue&type=script&lang=js&"
import style0 from "./CharColor.vue?vue&type=style&index=0&id=7fb2b415&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fb2b415",
  null
  
)

export default component.exports